module.exports = __webpack_public_path__ + "static/img/9.7d9a899.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fu_shen/9.png
// module id = dz/Z
// module chunks = 0